import { BaseIcon, BaseIconProps } from "./BaseIcon";

export function SearchIcon(props: BaseIconProps) {
  return (
    <BaseIcon {...props}>
      <path
        fill="currentColor"
        d="M24.645 21.999A13.13 13.13 0 1 0 22 24.645L28.354 31 31 28.358l-6.355-6.36ZM14.18 23.524a9.345 9.345 0 1 1 9.345-9.345 9.354 9.354 0 0 1-9.345 9.345Z"
      />
    </BaseIcon>
  );
}
